// Customer reviews shown on the public landing pages (/, /gift, /celebration).
// Single source of truth — edit here and every page updates.
//
// Source: real Google reviews of the Talebound listing (5.0, 3 reviews).
// Names shown as first name + last initial (tasteful testimonial convention);
// switch to full names if preferred — these are public Google reviews.

export const REVIEWS = [
  {
    name: 'Charlie W.',
    rating: 5,
    text: "I used this to make my wife a mother's day/birthday gift. It worked. She cried. Thank you guys, this is a great product.",
  },
  {
    name: 'Richard N.',
    rating: 5,
    text: 'Great experience with Talebound. The QR code feature was convenient. The quality of the book was nice! Thank you Talebound team!',
  },
  {
    name: 'Mary Ann',
    rating: 5,
    text: 'Easy to use! And my book turned out great!',
  },
  {
    name: 'Bobby I.',
    rating: 5,
    text: "Talebound is incredibly easy to use and such an awesome idea. The talk-to-chat feature made writing my story for my family feel like I was having a full conversation, with full responses, to tell my story my way. Knowing my voice will be kept and can be replayed forever is amazing. Highly recommend to everyone looking for a way to share their story for generations.",
  },
];

// Overall rating summary from the Google listing.
export const REVIEW_SUMMARY = { rating: 5.0, count: 4, source: 'Google' };
